import React from "react";
import { Col, Row, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import ArtImg from "./img/art.webp";
import Art2Img from "./img/art2.webp";
import styled from "styled-components";
import { setIsArtQrModal } from "../../../../redux/slices/modals";
import useQrConfigs from "../../../../hooks/useQrConfigs";
import { qrResetText } from "../../../../redux/slices/qrTextSettings";
import {
  qrCornetsInterior,
  qrCornetsOuter,
  qrPattern,
  qrResetSettings,
} from "../../../../redux/slices/qrSettings";
import { qrResetFrame } from "../../../../redux/slices/qrFrames";
import { qrOptionsReset } from "../../../../redux/slices/qrOptions";
import { setDesignType } from "../../../../redux/slices/customizeQr";
import { CustomImgDiv } from ".";
import { designTypes } from "../../../../constants/common";

function ArtQrBanner() {
  const lang = useSelector(
    (state) => state.changeLang.language.stepThree.qrMode
  );
  const { initialConfigs, currentConfigs } = useQrConfigs();

  const isSameConfigs =
    JSON.stringify(currentConfigs) === JSON.stringify(initialConfigs);

  const dispatch = useDispatch();

  const handleArtQrSwitch = () => {
    if (isSameConfigs) {
      dispatch(qrResetText());
      dispatch(qrResetSettings());
      dispatch(qrResetFrame());
      dispatch(qrOptionsReset());
      dispatch(setDesignType(designTypes.art));
      dispatch(qrPattern("small-dots"));
      dispatch(qrCornetsOuter("square"));
      dispatch(qrCornetsInterior("square"));
      return;
    }
    dispatch(setIsArtQrModal(true));
  };

  return (
    <section
      className="mt-3 rounded-3 px-3 px-lg-4 py-4"
      style={{
        background: "linear-gradient(to right, #4b15b2, #a20990, #ff4e51)",
      }}
    >
      <Row className="g-3 align-items-center">
        <Col xs={4} lg={3}>
          <CustomImgDiv className="position-relative h-100 w-100">
            <img
              src={ArtImg}
              className="img-fluid position-absolute top-50 start-50 translate-middle first"
              alt="logo-qr"
              loading="lazy"
              style={{ maxWidth: 151 }}
            />
            <img
              src={Art2Img}
              className="img-fluid position-absolute top-50 start-50 translate-middle second"
              alt="logo-qr"
              loading="lazy"
              style={{ maxWidth: 151 }}
            />
          </CustomImgDiv>
        </Col>
        <Col xs={8} lg={6}>
          <Row className="">
            <Col
              xs={12}
              lg={6}
              className="d-flex justify-content-start justify-content-lg-center align-items-center px-lg-0"
            >
              <div className="d-flex gap-2 align-items-center mb-lg-1">
                <ArtTitle className="fw-bold text-white">{lang[2]}✨</ArtTitle>
                <div
                  className="fs-7 text-white px-2 rounded-2 d-flex align-items-center justify-content-center"
                  style={{ background: "rgba(255, 255, 255, 0.27)" }}
                >
                  {lang[3]}
                </div>
              </div>
            </Col>
            <Col xs={12} lg={6}>
              <div className="text-gray fs-7 text-white">{lang[4]}</div>
            </Col>
          </Row>
        </Col>

        <Col xs={12} lg={3}>
          <Button
            variant="light"
            className="text-primary bg-white w-100 fw-bold"
            onClick={handleArtQrSwitch}
          >
            {lang[5]}
          </Button>
        </Col>
      </Row>
    </section>
  );
}

export default ArtQrBanner;

const ArtTitle = styled.div`
  font-size: 20px;
  @media (min-width: 992px) {
    font-size: 24px;
  }
`;
